var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-combobox", {
    attrs: {
      value: _vm.Model,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      items: _vm.items,
      label: _vm.label,
      multiple: _vm.multiple,
      "return-object": _vm.returnObject,
      chips: _vm.multiple,
      "small-chips": _vm.multiple,
      dense: _vm.dense,
      "menu-props": _vm.dropDownPosition,
      readonly: _vm.readonly,
      "search-input": _vm.searchInput,
      "error-count": _vm.errorCount(_vm.keyError),
      "error-messages": _vm.errors(_vm.keyError),
      error: _vm.hasErrors(_vm.keyError),
      "hide-details": "auto",
    },
    on: {
      input: function ($event) {
        return _vm.updateValue($event)
      },
      "update:searchInput": function ($event) {
        _vm.searchInput = $event
      },
      "update:search-input": function ($event) {
        _vm.searchInput = $event
      },
      change: function ($event) {
        _vm.searchInput = ""
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }